import { mString } from 'lib/helpers/utility';

import DrAvatar from './lib/components/DrAvatar';
import InfoCallout from './lib/components/InfoCallout';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const TotalPage = ({ estimate }) => {
  const {
    copay = 0,
    deductible = 0,
    coinsurance = 0,
    coinsuranceRate = 0,
    allowed = 0,
    providerCharges = 0,
    writeOff = 0,
    patientResponsibility = 0
  } = estimate ?? {};
  const balance = patientResponsibility;

  const rows = [
    { label: 'Total provider charges', value: mString(providerCharges) },
    { label: 'Insurance allowed amount', value: mString(allowed) },
    {
      label: 'Insurance adjustment (write-off)',
      value: `−${mString(writeOff)}`,
      muted: true
    },
    { label: 'Remaining deductible', value: mString(deductible) },
    coinsurance > 0 && {
      label: `Coinsurance (${coinsuranceRate}% of remaining)`,
      value: mString(coinsurance)
    },
    copay > 0 && { label: 'Copay', value: mString(copay) }
  ].filter(Boolean);

  const breakdownParts = [
    deductible > 0 && `${mString(deductible)} deductible`,
    coinsurance > 0 && `${mString(coinsurance)} coinsurance`,
    copay > 0 && `${mString(copay)} copay`
  ].filter(Boolean);

  return (
    <div className="flex flex-col gap-5">
      <SlideHeader title="Your balance" />

      <SpeechBubble variant="default">
        Here's how your estimated balance of {mString(balance)} adds up:
      </SpeechBubble>

      <div className="overflow-hidden rounded-xl border border-solid border-neutral-200 shadow-sm">
        <div className="flex flex-col divide-y divide-neutral-50">
          {rows.map((row) => (
            <div key={row.label} className="flex items-center justify-between px-4 py-2.5">
              <span className="text-sm text-neutral-600">{row.label}</span>
              <span
                className={`text-sm font-500 ${row.muted ? 'text-neutral-400' : 'text-primary-900'}`}>
                {row.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#0093C4] to-[#00B8E8] p-6 text-center text-white">
        <p className="mb-2 text-sm font-500 opacity-80">Your estimated total for today is</p>
        <p className="text-4xl font-800">{mString(balance)}</p>
        {breakdownParts.length > 0 && (
          <p className="mt-1 text-sm opacity-60">{breakdownParts.join(' + ')}</p>
        )}
        <DrAvatar variant={5} size="medium" className="absolute -bottom-4 -right-4 opacity-30" />
      </div>

      <InfoCallout />
    </div>
  );
};

export default TotalPage;
